import { Injectable } from '@angular/core';

import { ContractType } from '@dav-model/api/response/pending-contract.response.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  openPendingDaysModal: BehaviorSubject<any> = new BehaviorSubject<any>({ flag: false, message: '' });
  openResetSessionModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  openUpdateInfoModal: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  openEditContractModalBS: BehaviorSubject<any> = new BehaviorSubject<any>({
    flag: false,
    contract: undefined,
    success: false
  });
  openAddLienholderModalBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  openForgotUsernameModalBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  openForgotPasswordModalBS: BehaviorSubject<any> = new BehaviorSubject<any>({ flag: false, username: '' });
  openRequestAccountModalBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  openReportProblemModalBS: BehaviorSubject<any> = new BehaviorSubject<any>({ img: '', flag: false, success: false });
  openUpdatePasswordModalBS: BehaviorSubject<any> = new BehaviorSubject<any>({ username: '', flag: false, flowType: 'LEGACY', actionType: 'UPDATE' });
  openIncorrectProvinceModalBS: BehaviorSubject<{ isCoBorrower: boolean, flag: boolean }> = new BehaviorSubject<{
    isCoBorrower: boolean,
    flag: boolean
  }>({ isCoBorrower: false, flag: false });

  openEmulateDealerModalBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  closAllModalsBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


  constructor(private modalBootstrap: NgbModal) {
  }

  openResetModal() {
    this.openResetSessionModal.next(true);
  }

  openIncorrectProvinceModal(isCoBorrower: boolean = false) {
    this.openIncorrectProvinceModalBS.next({ isCoBorrower, flag: true });
  }

  closeIncorrectProvinceModal() {
    this.openIncorrectProvinceModalBS.next({ isCoBorrower: false, flag: false });
  }

  closeResetModal() {
    this.openResetSessionModal.next(false);
  }

  openUpdateModal() {
    this.openUpdateInfoModal.next(true);
  }

  closeUpdateModal() {
    this.openUpdateInfoModal.next(false);
  }

  openRequestAccountModal() {
    this.openRequestAccountModalBS.next(true);
  }

  closeRequestAccountModal() {
    this.openRequestAccountModalBS.next(false);
  }

  openEmulateDealerModal() {
    this.openEmulateDealerModalBS.next(true);
  }

  closeEmulateDealerModal() {
    this.openEmulateDealerModalBS.next(false);
  }

  openPendingDaysWarningModal(message: string) {
    this.openPendingDaysModal.next({ flag: true, message });
  }

  openEditContractModal(contract: ContractType, submitted: boolean, success: boolean) {
    this.openEditContractModalBS.next({ flag: true, contract: contract, submitted: submitted, success: success });
  }

  closeEditContractModal(submitted: boolean, success: boolean) {
    this.openEditContractModalBS.next({ flag: false, contract: undefined, submitted: submitted, success: success });
  }

  openReportProblemModal(img: string, success: boolean) {
    this.openReportProblemModalBS.next({ img: img, flag: true, success: success });
  }

  closeReportProblemModal() {
    this.openReportProblemModalBS.next({ img: '', flag: false });
  }

  openupdatePasswordModal(model: UpdatePasswordModel) {
    this.openUpdatePasswordModalBS.next(model);
  }

  closeUpdatePasswordModal(username: string) {
    this.openUpdatePasswordModalBS.next({ username: username, flag: false });
  }

  openAddLienholderModal() {
    this.openAddLienholderModalBS.next(true);
  }

  closeAddLienholderModal() {
    this.openAddLienholderModalBS.next(false);
  }

  openForgotUsernameModal() {
    this.openForgotUsernameModalBS.next(true);
  }

  closeForgotUsernameModal() {
    this.openForgotUsernameModalBS.next(false);
  }

  openForgotPasswordModal(username: string = '') {
    this.openForgotPasswordModalBS.next({ flag: true, username });
  }

  closeForgotPasswordModal() {
    this.openForgotPasswordModalBS.next({ flag: false, username: '' });
  }

  closeAllModals() {
    this.closAllModalsBS.next(true);
    this.openAddLienholderModalBS.next(false);
    this.openForgotUsernameModalBS.next(false);
    this.openUpdatePasswordModalBS.next({ username: '', flag: false, flowType: 'LEGACY', actionType: 'UPDATE' });
    this.openPendingDaysModal.next({ flag: false, message: '' });
    this.openResetSessionModal.next(false);
    this.openUpdateInfoModal.next(false);
    this.openForgotPasswordModalBS.next({ flag: false, username: '' });
    this.openEditContractModalBS.next({ flag: false, contract: undefined, submitted: false, success: false });
    this.openRequestAccountModalBS.next(false);
    this.openReportProblemModalBS.next({ username: '', flag: false, success: false });
    this.openEmulateDealerModalBS.next(false);
    this.closeIncorrectProvinceModal();
    this.modalBootstrap.dismissAll();
  }
}

export class UpdatePasswordModel {
  username: string;
  flag: boolean;
  stateToken?: string;
  flowType: 'OKTA' | 'LEGACY';
  actionType: 'UPDATE' | 'RESET';

  constructor() {
    this.username = '';
    this.flag = false;
    this.flowType = 'LEGACY';
    this.actionType = 'UPDATE';
  }
}

